import grammar from '../../assets/images/copy.jpg';
export const fixGrammar = {
  title: 'Grammar Fixer',
  description: `Our advanced grammar fixing tool utilizes OpenAI's technology to quickly and accurately identify and correct errors, helping you elevate your writing.`,
  cta: 'Fix My Grammar',
  image: grammar,
  launched: true,
  link: '/grammar',
};
